import { OutverseApi, Configuration } from "@outverse-video/outverse-api-client-lib";
import globalAxios from "axios";
import { firebaseAuth, refreshFirebaseToken } from "./firebase/client";
import { env } from "$env/dynamic/public";
import { MAINTENANCE_MODE_ON } from "./consts";
import { track } from "./analytics";
import { PUBLIC_ENV } from "$env/static/public";

export const VERCEL = {
  vercel_env: import.meta.env.VITE_VERCEL_ENV,
  pr: import.meta.env.VITE_VERCEL_GIT_PULL_REQUEST_ID,
  branch: import.meta.env.VITE_VERCEL_GIT_COMMIT_REF,
};

// default to local backend when env var not provided (e.g. unit-tests)
let basePath = env.PUBLIC_API_URL || "http://127.0.0.1:8000";

if (VERCEL.vercel_env === "preview") {
  console.log("API: detected running as preview app");
  if (VERCEL.pr) {
    basePath = `https://outverse-kqlrtjs2345-pr-${VERCEL.pr}.herokuapp.com`;
    console.log(`API: detected app is based on pull request${VERCEL.pr}`);
  }
}
// support dynamic env api url for testing
if (PUBLIC_ENV === "test" && env.PUBLIC_API_URL) {
  console.log(`env.PUBLIC_API_URL = ${env.PUBLIC_API_URL}`);
  basePath = env.PUBLIC_API_URL;
}

if (!import.meta.env.VITE_SCRIPT) {
  console.log("API: URL set to ", basePath);
}

export const API_URL = basePath;
export const WS_URL = API_URL.replace(/^http/, "ws").replace("127.0.0.1", "localhost"); // change http(s) -> ws(s)
export const apiClientConfig = new Configuration({ basePath });

const repeatRequest = (error: any) => {
  const currentUser = firebaseAuth.currentUser;
  if (currentUser && !error.config.alreadyRepeated) {
    return refreshFirebaseToken(currentUser, apiClientConfig).then(() => {
      error.config.headers["Authorization"] = apiClientConfig.apiKey;
      error.config.alreadyRepeated = true;
      return globalAxios.request(error.config);
    });
  }
  return Promise.reject(error);
};

globalAxios.defaults.withCredentials = true;

// request interceptor prevent non-GET requests from being sent when in maintenance mode
globalAxios.interceptors.request.use(function (config) {
  const controller = new AbortController();
  const unsafeMethods = ["post", "patch", "put", "delete"];

  if (MAINTENANCE_MODE_ON && config.method && unsafeMethods.includes(config.method)) {
    track("Maintenance Mode Request Cancelled");
    console.log("Maintenance mode is on, cancelling request");
    controller.abort();
  }

  return {
    ...config,
    signal: controller.signal,
  };
});

globalAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response ? error.response.status : null;
    if (status === 401) {
      return repeatRequest(error);
    }
    return Promise.reject(error);
  }
);

const outverseApiClient = new OutverseApi(apiClientConfig);

export default outverseApiClient;
